import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { Navbar, Sidebar, ScrollToTop } from './components'

import {
  Home,
  Careers,
  Error,
  Shipping,
  SingleProduct,
  Checkout,
  Products,
  Cart,
  SuccessfulPayment,
  About,
  AppPage,
  Community,
  PrivacyPolicy,
  TermsOfUse,
  SecurityAndTrust,
  CookiePolicy,
  IndoorPanTiltCamera,
  Plan,
  Support,
  HowToChoose,
  BlogPage,
  FutureOfSmart,
  WhySecurityCamera,
  WhyBatteryLife,
  WirelessSecuritySystems,
  RegisterPage,
  LoginPage,
  SmartBirdFeeder,
  StripeProducts,
  StripeSingleProduct,
} from './pages'

function App() {
  return (
    <Router>
        <Switch>
          <Route exact path='/index'>
            <Home />
          </Route>
          <Route exact path='/'>
            <Home />
          </Route>
          <Route exact path='/careers'>
            <Careers />
          </Route>
          <Route exact path='/about'>
            <About />
          </Route>
          <Route exact path='/app'>
            <AppPage />
          </Route>
          <Route exact path='/community'>
            <Community />
          </Route>
          <Route exact path='/shipping'>
            <Shipping />
          </Route>
          <Route exact path='/cart'>
            <Cart />
          </Route>
          <Route exact path='/privacy-policy'>
            <PrivacyPolicy />
          </Route>
          <Route exact path='/terms-of-use'>
            <TermsOfUse />
          </Route>
          <Route exact path='/security-and-trust'>
            <SecurityAndTrust />
          </Route>
          <Route exact path='/cookie-policy'>
            <CookiePolicy />
          </Route>
          <Route exact path='/indoor-pan-tilt-camera'>
            <IndoorPanTiltCamera />
          </Route>
          <Route exact path='/plan'>
            <Plan />
          </Route>
          <Route exact path='/support'>
            <Support />
          </Route>
          <Route exact path='/products'>
            <Products />
          </Route>
          <Route exact path='/products/:slug' children={<SingleProduct />} />
          <Route exact path='/stripe-products'>
            <StripeProducts />
          </Route>
          <Route exact path='/stripe-products/:productId' children={<StripeSingleProduct />} />
          <Route exact path='/checkout'>
            <Checkout />
          </Route>
          <Route exact path='/successful_payment'>
            <SuccessfulPayment />
          </Route>
          <Route exact path='/how-to-choose-the-best-home-cameras-for-your-needs'>
            <HowToChoose />
          </Route>
          <Route exact path='/blog'>
            <BlogPage />
          </Route>
          <Route exact path='/the-future-of-smart-homes'>
            <FutureOfSmart />
          </Route>
          <Route exact path='/why-your-security-camera-wont-connect-to-wifi'>
            <WhySecurityCamera />
          </Route>
          <Route exact path='/why-battery-life-is-a-challenge-for-wireless-security-cameras'>
            <WhyBatteryLife />
          </Route>
          <Route exact path='/wireless-security-systems-are-they-safe-enough'>
            <WirelessSecuritySystems />
          </Route>
          <Route exact path='/login'>
            <LoginPage />
          </Route>
          <Route exact path='/register'>
            <RegisterPage />
          </Route>
          <Route exact path='/smart-bird-feeder'>
            <SmartBirdFeeder />
          </Route>
          <Route path='*'> 
            <Error />
          </Route>
        </Switch>
    </Router>
  )
}

export default App

// const Layout: React.FC = ({ children }) => {
//   return (
//     <>
//       <ScrollToTop />
//       <Navbar />
//       <Sidebar />
//       {children}
//     </>
//   )
// }
